interface IProps {
    color?: string;
    size?: number;
    onClick?: () => void;
    stoke?: string;
}

export const MemberDiamond = (props: IProps) => {
    const { color } = props;
    return (
        <svg
            id="a"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 -2 18.21 16.14"
        >
            <defs>
                <style></style>
            </defs>
            <path
                className="b"
                fill={color || "#fff"}
                d="M9.11,0H4.37c-.21,0-.41,.1-.54,.27L.13,5.23c-.19,.26-.18,.61,.03,.85l8.68,9.95c.13,.15,.37,.15,.51,0L18.05,6.08c.21-.24,.22-.59,.03-.85L14.38,.27c-.13-.17-.33-.27-.54-.27h-4.73ZM4.11,1.76c.07-.1,.21-.08,.26,.03l1.37,3.23c.05,.11-.03,.23-.14,.23H2.01c-.12,0-.19-.15-.12-.26L4.11,1.76Zm9.79,.03c.05-.11,.19-.13,.26-.03l2.22,3.23c.07,.11,0,.26-.12,.26h-3.59c-.11,0-.18-.12-.14-.23l1.37-3.23Zm-4.89-.53c.06-.09,.2-.09,.26,0l2.39,3.78c.06,.09-.01,.2-.13,.2H6.74c-.11,0-.19-.11-.13-.2l2.39-3.78Zm.27,13.17c-.05,.15-.27,.15-.32,0l-2.76-7.86c-.04-.11,.04-.23,.16-.23h5.53c.12,0,.2,.12,.16,.23l-2.76,7.86Z"
            />
        </svg>
    );
};
